import { themeGet } from '@styled-system/theme-get';
import styled from '@emotion/styled';
import { Box, Card, Text } from '@qga/roo-ui/components';
import { HorizontalRule } from 'components/Layout/index';
import { FC, ReactNode } from 'react';

interface ActionBarProps {
  label: string;
  children: ReactNode;
}

const ActionContainer = styled(Box)`
  padding: ${themeGet('space.4')};

  > *:not(:first-of-type) {
    margin-top: ${themeGet('space.4')};
  }
`;

export const ActionBar: FC<ActionBarProps> = ({ label, children }) => (
  <Card display="flex" flexDirection="column" textAlign="left" borderRadius="default" p={0}>
    <Text as="div" fontSize="lg" m={4}>
      {label}
    </Text>
    <HorizontalRule m={0} />
    <ActionContainer>{children}</ActionContainer>
  </Card>
);
